import { Box, Typography } from '@mui/material';
import { DpContainer } from '@/components/blocks/DpContainer';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { getImage } from '@/utils/getImage';
import { fillPersonalization } from '@/components/blocks/DpRepurchaseCoupon/fillPersonalization';
import {
	usePersonalizationPurchase,
	usePersonalizationTokens,
} from '@/components/blocks/DpRepurchaseCoupon/usePersonalizationTokens';
import {
	purchaseDetailSX,
	purchaseEyebrowSX,
	purchaseImageSX,
	purchaseInfoSX,
	purchaseNameSX,
	purchaseProductSX,
	purchaseRootSX,
	purchaseTextSX,
} from '@/components/blocks/DpRepurchaseCoupon/styles/purchase';

export type RepurchasePurchaseContent = {
	eyebrow?: string;
	text?: string;
};

export const RepurchasePurchase = ({
	eyebrow = 'Lo que ya es tuyo',
	text = 'Todo lo que ves abajo lo elegimos a partir de esta compra, para que la aproveches al máximo.',
}: RepurchasePurchaseContent) => {
	const { product, size } = usePersonalizationPurchase();
	const tokens = usePersonalizationTokens();

	if (!product) {
		return null;
	}

	return (
		<DpContainer withoutmargin clampToViewport>
			<Box component="section" aria-label={eyebrow} sx={purchaseRootSX}>
				<Linkable href={product.seo?.href} sx={purchaseProductSX} aria-label={product.name}>
					<Box sx={purchaseImageSX}>
						<Img src={getImage(product.thumbnail)} alt={product.name} />
					</Box>
					<Box sx={purchaseInfoSX}>
						<Typography component="p" sx={purchaseEyebrowSX}>
							{fillPersonalization(eyebrow, tokens)}
						</Typography>
						<Typography component="p" sx={purchaseNameSX}>
							{product.name}
						</Typography>
						{size ? (
							<Typography component="p" sx={purchaseDetailSX}>
								{`Talla ${size}`}
							</Typography>
						) : null}
					</Box>
				</Linkable>
				<Typography component="p" sx={purchaseTextSX}>
					{fillPersonalization(text, tokens)}
				</Typography>
			</Box>
		</DpContainer>
	);
};
